import React from 'react';
import ModelViewItem from './model-view-item';

const ViewModalDialouge = () => {


    return(
        
        <div className="modal fade register-model" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="close-model" data-dismiss="modal">X</div>
                        <div className="title-content">
                            <h3 className="model-title">إظهار البيانات</h3>
                        </div>
                        <form>
                            <div className="row">
                                <div className="col-lg-6">
                                    <ModelViewItem dataDisplay={"اسم المستخدم"} dataView={"أحمد محمد البنا"} />
                                </div>
                                <div className="col-lg-6">
                                    <ModelViewItem dataDisplay={"رقم الموبايل"} dataView={"01120303508"} />
                                </div>
                                <div className="col-lg-6">
                                    <ModelViewItem dataDisplay={"عدد الدراسات"} dataView={"100"} />
                                </div>
                                <div className="col-lg-6">
                                    <ModelViewItem dataDisplay={"البريد الالكتروني"} dataView={"me@me.com"} />
                                </div>
                                <div className="col-lg-6">
                                    <ModelViewItem dataDisplay={"اسم المستخدم"} dataView={"أحمد محمد البنا"} />
                                </div>
                                <div className="col-lg-6">
                                    <ModelViewItem dataDisplay={"اسم المستخدم"} dataView={"أحمد محمد البنا"} />
                                </div>

                            </div>
                              

                        </form>
                    </div>
                </div>
            </div>
         </div>
    );

};
export default ViewModalDialouge;
